/* LumaVibes universal product gallery: arrows + swipe + no horizontal page drag.
   Works on any custom product section using #lv-root .lv-main-wrap with a main
   <img> and .lv-thumb thumbnails. Prefix-agnostic. */
(function(){
  // Upgrade a Shopify CDN image URL to a higher render width so swapped images
  // stay crisp on retina screens (main image is generated at width=900 which
  // looks soft when shown large). Bumps the width param to 1600.
  function hi(url){
    if(!url)return url;
    if(/[?&]width=/.test(url))return url.replace(/([?&]width=)\d+/,'$11600');
    if(/[?&]/.test(url))return url+'&width=1600';
    return url+'?width=1600';
  }
  function init(){
    var root=document.getElementById('lv-root');
    if(!root)return;
    var wrap=root.querySelector('.lv-main-wrap');
    if(!wrap)return;
    if(wrap.getAttribute('data-lvgal')==='1')return; // idempotent
    wrap.setAttribute('data-lvgal','1');
    var mainImg=wrap.querySelector('img');
    if(!mainImg)return;

    var thumbs=Array.prototype.slice.call(root.querySelectorAll('.lv-thumb'));
    function imgList(){
      var list=[];
      thumbs.forEach(function(t){
        var oc=t.getAttribute('onclick')||'';
        var m=oc.match(/(https?:[^'\"]+)/);
        if(m){list.push(m[1]);}
        else{var im=t.querySelector('img');if(im)list.push(im.src);}
      });
      if(!list.length&&mainImg.src)list.push(mainImg.src);
      return list;
    }
    var imgs=imgList();
    if(imgs.length<2)return;

    // Warm the cache with the hi-res versions so navigation is instant.
    imgs.forEach(function(u){var p=new Image();p.src=hi(u);});

    // Compare absolute, query-free URLs: a section may render the main image as
    // a protocol-relative //cdn URL while thumbnail srcs resolve to absolute
    // ones, which used to make the index lookup always fall back to photo 1.
    function abs(u){
      try{return new URL(u||'',location.href).href.split('?')[0];}
      catch(e){return (u||'').split('?')[0];}
    }
    function indexOfSrc(){
      var src=abs(mainImg.getAttribute('src'));
      for(var k=0;k<imgs.length;k++){
        if(abs(imgs[k])===src)return k;
      }
      return 0;
    }

    var cur=indexOfSrc(); // photo the gallery believes the visitor is on
    var want=null;        // url of the swap currently in flight
    var token=0;          // only the newest navigation may touch the image

    // The section itself can change the main image (colour swatch, thumbnail),
    // so re-read the DOM before navigating - unless what is on screen is our
    // own swap, which the visitor may be ahead of.
    function at(){
      var src=abs(mainImg.getAttribute('src'));
      if(want&&src===abs(want))return cur;
      if(imgs[cur]&&abs(imgs[cur])===src)return cur;
      cur=indexOfSrc();
      want=null;
      return cur;
    }

    // Swap on load only. img.decode() is not reliable in every browser - it can
    // stay pending on an image that is already complete, and a swap waiting on
    // it would freeze the whole gallery. Every callback below is stamped with
    // the navigation that created it, so a late one from an earlier click can
    // no longer drag the visitor back to a photo they already left.
    function show(i){
      if(i<0)i=imgs.length-1;
      if(i>=imgs.length)i=0;
      cur=i;
      var url=hi(imgs[i]);
      want=url;
      var my=++token;
      thumbs.forEach(function(t){t.classList.remove('active');});
      if(thumbs[i])thumbs[i].classList.add('active');
      function swap(){if(my!==token)return;mainImg.src=url;}
      var loader=new Image();
      loader.onload=swap;loader.onerror=swap;
      loader.src=url;
      if(loader.complete&&loader.naturalWidth){swap();return;}
      setTimeout(swap,1200); // network stalled: show it anyway
    }
    function go(step){show(at()+step);}

    if(!wrap.querySelector('.lv-nav')){
      var prev=document.createElement('div');
      prev.className='lv-nav lv-nav-prev';prev.textContent='‹';
      prev.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();go(-1);});
      var next=document.createElement('div');
      next.className='lv-nav lv-nav-next';next.textContent='›';
      next.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();go(1);});
      wrap.appendChild(prev);wrap.appendChild(next);
    }

    // Swipe. A tap on an arrow also raises touch events on the wrap, so a touch
    // that starts on an arrow is left to the click handler alone - otherwise one
    // tap would step twice.
    function onNav(e){return !!(e.target&&e.target.closest&&e.target.closest('.lv-nav'));}
    var x0=null,y0=null;
    wrap.addEventListener('touchstart',function(e){
      if(onNav(e)){x0=null;y0=null;return;}
      x0=e.changedTouches[0].clientX;y0=e.changedTouches[0].clientY;
    },{passive:true});
    wrap.addEventListener('touchend',function(e){
      if(x0===null)return;
      var dx=e.changedTouches[0].clientX-x0;
      var dy=e.changedTouches[0].clientY-y0;
      if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)){
        if(dx<0)go(1);else go(-1);
      }
      x0=null;y0=null;
    },{passive:true});
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init);
  }else{init();}
  document.addEventListener('shopify:section:load',init);
})();
